<template>
  <span
    data-node-content
    data-cy="bracket-operator"
    class="px-1"
    :class="[
      node.context?.matchedBracketsId
        ? node.context?.color
        : 'font-semibold text-red-600',
      { 'border border-gray-400': node.context?.isActive },
    ]"
  >
    {{ node.content }}
  </span>
</template>
<script lang="ts" setup>
import type { BracketOperator } from "@/enums/customAttributesV2";
import type { BracketContext, EditorNode } from "@/models/TextEditor";

interface BracketNode extends Omit<EditorNode, "content" | "context"> {
  content: BracketOperator;
  context?: BracketContext;
}

defineProps<{
  node: BracketNode;
}>();
</script>
